export default __webpack_public_path__ + "static/media/sticker-d.4a184788.png";